import { Color, Gradient } from "./options";

const colorGradientMap = {
  [Color.Primary]: undefined,
  [Color.Secondary]: undefined,
  [Color.Red]: undefined,
  [Color.Yellow]: undefined,
  [Color.Purple]: undefined,
  [Color.Grey]: undefined,
  [Color.Gyldendal]: undefined,

  [Color.Blurple]: Gradient.Blurple,
  [Color.Gold]: Gradient.Gold
};

export const mapColorToGradient = (color: Color): Gradient | undefined => colorGradientMap[color];
